export const SITE_URL = "https://shophousealain.com";
export const SITE_NAME = "Shop House General Trading";

export const STORE = {
  name: SITE_NAME,
  email: "shophouse2025@gmail.com",
  mobile: "+971507191804",
  mobileDisplay: "+971 50 719 1804",
  mobileLocalDisplay: "050 719 1804",
  landline: "+97137224922",
  landlineDisplay: "03 722 4922",
  whatsapp: "971507191804",
  streetAddress: "Al Ain Town Center, near Lucky Plaza",
  addressLocality: "Al Ain",
  addressRegion: "Abu Dhabi",
  addressCountry: "AE",
  latitude: 24.2217036,
  longitude: 55.7727053,
  facebook: "https://www.facebook.com/share/17iRxbWbFQ/",
  instagram: "https://www.instagram.com/shophouseuae",
} as const;

export const STORE_COORDINATES = `${STORE.latitude},${STORE.longitude}`;
export const MAP_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(STORE_COORDINATES)}&dir_action=navigate`;

